// eBikeGo product catalogue — 6 core series (2026-27)
// Source: eBikeGo Cycle Catalog 2026-27 PDF
export const PRODUCTS = [
  {
    slug: "urban-ecycles",
    name: "Urban E-Cycles",
    tagline: "Power meets style.",
    headline: "Smart, efficient, built for the new generation of urban riders.",
    categories: ["urban"],
    categoryLabel: "Urban E-Cycles",
    color: "Matte Black",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/tcqe69pz_Urban%20E-Cycles.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/tcqe69pz_Urban%20E-Cycles.png",
    gallery: [],
    keySpecs: { range: "60 km", speed: "25 km/h", motor: "250W", battery: "36V 10.4Ah", charge: "4–5 hrs" },
    description:
      "Electric cycles built to power your daily rides. The Urban series pairs a 250W motor with a removable Li-Ion pack, 5-level pedal assist and dual disc brakes — engineered for stop-start city traffic and everyday commutes.",
    highlights: [
      { title: "250W BLDC motor", text: "Instant torque for start-stop city riding without noise or fumes." },
      { title: "5-level pedal assist", text: "Dial power up for hills or ease off for gentle cruises." },
      { title: "36V 10.4Ah battery", text: "Removable Li-Ion pack — charge indoors, ride anywhere." },
      { title: "Dual disc brakes", text: "Predictable stopping in wet and dry city conditions." },
    ],
    specs: {
      Motor: "250W BLDC",
      Battery: "36V 10.4Ah Removable Li-Ion",
      Transmission: "5-Level Pedal Assist",
      Brakes: "Front & Rear Disc",
      "Max Speed": "25 km/h",
      Charging: "4–5 hrs",
    },
    variants: [
      { name: "Urban Pro", colors: ["Matte Black", "Racing Red"] },
      { name: "Evo Tour", colors: ["Matte Black", "Forest Green"] },
    ],
    badges: ["Urban", "5-Level Pedal Assist", "Made for India"],
  },
  {
    slug: "mtb-series",
    name: "MTB Series",
    tagline: "Built for performance. Made for adventure.",
    headline: "For the adventure seekers who break their limits.",
    categories: ["mtb"],
    categoryLabel: "MTB Series",
    color: "Matte Black",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/tyc442pm_MTB%20Series.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/tyc442pm_MTB%20Series.png",
    gallery: [],
    keySpecs: { range: "12-speed", speed: "Multi-terrain", motor: "Analog", battery: "—", charge: "—" },
    description:
      "A lightweight-frame MTB range engineered for Indian roads and weekend trails. Front suspension, dual disc brakes and a 12-speed drivetrain across four wheel sizes — pick the one that matches your ride.",
    highlights: [
      { title: "Front suspension", text: "Soaks up potholes, roots and monsoon-worn tarmac." },
      { title: "Dual disc brakes", text: "Confident stopping across wet and dry conditions." },
      { title: "12-speed drivetrain", text: "Wide gear range for climbs, flats and fast descents." },
      { title: "Lightweight frame", text: "Sharp handling with all-day comfort geometry." },
    ],
    specs: {
      Frame: "Lightweight alloy",
      Brakes: "Dual disc",
      Transmission: "12-Speed",
      Suspension: "Front",
      "Tyre Options": "24\" / 26\" / 27.5\" / 29\"",
    },
    variants: [
      { name: "24\" Tyres", colors: ["Grey / Orange", "Blue / Neon"] },
      { name: "26\" Tyres", colors: ["Matte Black", "Olive Green", "Steel Blue"] },
      { name: "27.5\" Tyres", colors: ["Black / Neon Green", "Blue / Orange"] },
      { name: "29\" Tyres", colors: ["Grey / Neon Green", "Navy / Orange"] },
    ],
    warranty: "Lifetime warranty on frame & components (26\", 27.5\", 29\").",
    badges: ["MTB", "12-Speed", "Front Suspension"],
  },
  {
    slug: "foldable",
    name: "Foldable",
    tagline: "Fold. Ride. Go further.",
    headline: "Smarter technology. Lighter design. Longer range.",
    categories: ["foldable", "urban"],
    categoryLabel: "Foldable",
    color: "Matte Black",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/pecycpa2_Foldable.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/pecycpa2_Foldable.png",
    gallery: [],
    keySpecs: { range: "150 km", speed: "25 km/h", motor: "250W", battery: "36V 13Ah", charge: "5–6 hrs" },
    description:
      "A foldable e-cycle for multi-modal city life — folds into elevators, car boots and studio flats. Paired with a 150 km range, 7-speed Shimano drivetrain and app connect, it makes the longest commute feel effortless.",
    highlights: [
      { title: "Up to 150 km range", text: "36V 13Ah pack — the longest range in the eBikeGo line-up." },
      { title: "7-speed Shimano", text: "Smooth, precise shifts for varied city gradients." },
      { title: "Hydraulic disc brakes", text: "Front & rear hydraulic stopping for consistent bite." },
      { title: "App connect & navigation", text: "Pair the bike, plan routes and track rides from your phone." },
    ],
    specs: {
      Motor: "250W High-Performance BLDC",
      Battery: "36V 13Ah Removable Li-Ion",
      Range: "Up to 150 km per charge",
      Transmission: "7-Speed Shimano",
      Brakes: "Hydraulic Disc (Front & Rear)",
      Lighting: "Auto LED Headlight",
      Connectivity: "App Connect & Navigation",
      "Max Speed": "25 km/h",
    },
    variants: [
      { name: "Foldable", colors: ["Matte Black", "Ocean Blue"] },
    ],
    badges: ["Foldable", "150 km Range", "App Connect"],
  },
  {
    slug: "e-dirt",
    name: "E-Dirt",
    tagline: "Built wild, for the doers.",
    headline: "Made for adventures. Tweaked for performance.",
    categories: ["e-dirt", "mtb"],
    categoryLabel: "E-Dirt",
    color: "Charcoal / Neon",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/zlnnnaxl_E-Dirt.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/zlnnnaxl_E-Dirt.png",
    gallery: [],
    keySpecs: { range: "80 km", speed: "25 km/h", motor: "High-perf.", battery: "Li-Ion", charge: "5–6 hrs" },
    description:
      "A rugged e-dirt cycle built for trails, dunes and everything in between. Powerful motor, full-suspension chassis and disc brakes make it the weekend warrior you can also ride to work.",
    highlights: [
      { title: "Powerful motor", text: "High performance for off-road and city rides." },
      { title: "Full suspension", text: "Built to handle rough terrains with ease." },
      { title: "Long battery life", text: "Advanced Li-Ion pack for extended rides." },
      { title: "Lightweight frame", text: "Strong, durable and easy to handle." },
    ],
    specs: {
      Frame: "Lightweight full-suspension",
      Brakes: "Front & rear disc",
      Battery: "Removable Li-Ion",
      "Max Speed": "25 km/h",
      Suspension: "Front + Rear",
    },
    variants: [
      { name: "E-Dirt", colors: ["Charcoal / Neon Yellow"] },
    ],
    badges: ["E-Dirt", "Full Suspension", "Off-Road Ready"],
  },
  {
    slug: "cargo-utility",
    name: "Cargo Utility",
    tagline: "Built to deliver.",
    headline: "Strong, reliable, efficient — made for fleet business.",
    categories: ["cargo", "utility"],
    categoryLabel: "Cargo Utility",
    color: "Fleet Black",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/bbm4i4nx_Cargo%20Utility.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/bbm4i4nx_Cargo%20Utility.png",
    gallery: [],
    keySpecs: { range: "120 km", speed: "25 km/h", motor: "Cargo-tuned", battery: "Li-Ion", charge: "5–6 hrs" },
    description:
      "A purpose-built cargo e-cycle for last-mile delivery, retail supply and B2B fleet operations. High payload capacity, a long-range battery and a strong frame — engineered to move more with less.",
    highlights: [
      { title: "180 kg+ payload", text: "High payload capacity for daily heavy loads." },
      { title: "120 km range", text: "Go the distance. Deliver more per charge." },
      { title: "Made to last", text: "Strong frame, reliable performance — built for daily fleet use." },
      { title: "Zero emissions", text: "Clean deliveries with lower running costs than fuel." },
    ],
    specs: {
      "Payload Capacity": "180 kg+",
      "Range / Charge": "120 km",
      "Max Speed": "25 km/h",
      Frame: "Reinforced cargo",
      Brakes: "Front & rear disc",
      Battery: "Removable Li-Ion",
    },
    useCases: [
      "E-commerce logistics",
      "FMCG & retail supply",
      "Milk & dairy supply",
      "Courier & parcel",
      "B2B & fleet operations",
    ],
    warranty: "Lifetime warranty.",
    variants: [
      { name: "Cargo e-Cycle", colors: ["Fleet Black"] },
    ],
    badges: ["Cargo", "180 kg+ Payload", "Lifetime Warranty"],
  },
  {
    slug: "kids-cycles",
    name: "Kids Cycles",
    tagline: "Built for the first adventurers.",
    headline: "Safe, sturdy and joyfully designed bicycles for growing riders.",
    categories: ["kids"],
    categoryLabel: "Kids Cycles",
    color: "Ocean Blue",
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/4ld1wg2r_Kids%20Cycles.png",
    hero:  "https://customer-assets-lqy194kg.emergentagent.net/job_bike-catalog-9/artifacts/4ld1wg2r_Kids%20Cycles.png",
    gallery: [],
    keySpecs: { range: "Non-electric", speed: "Kid-safe", motor: "—", battery: "—", charge: "—" },
    description:
      "Made to build confidence, comfort and control in every first ride. Steel-frame safety, training wheels, IC carrier and thoughtful details across four sizes — pick the wheel size that matches your rider.",
    highlights: [
      { title: "Safe, sturdy build", text: "Steel frame with safety brakes and full chain cover." },
      { title: "Training wheels", text: "Confidence-building support on the 12\", 14\" and 16\" sizes." },
      { title: "Comfort seat", text: "Padded seat with back-support on the smallest size." },
      { title: "Playful colourways", text: "Multiple joyful colours across every wheel size." },
    ],
    specs: {
      Frame: "Steel (12\" / 14\" / 16\") · Lightweight (20\")",
      Brakes: "Safety brakes",
      "Included": "Training wheels · IC carrier",
      "Age Guide": "12\" (3–5 yr) · 14\" (4–7 yr) · 16\" (6–9 yr) · 20\" (9–13 yr)",
    },
    variants: [
      { name: "12\" Wheel", colors: ["Playful Blue", "Cool Green", "Sporty Orange"] },
      { name: "14\" Wheel", colors: ["Racing Red", "Ocean Blue", "Sunshine Yellow"] },
      { name: "16\" Wheel", colors: ["Magma Red", "Aqua Blue", "Sunburst Yellow"] },
      { name: "20\" Wheel", colors: ["Rapid Red", "Ocean Blue", "Lime Green"] },
    ],
    badges: ["Kids", "Safety First", "4 Sizes"],
  },
];

// Ordered filter tabs
export const CATEGORIES = [
  { id: "all",      label: "All Models" },
  { id: "urban",    label: "Urban" },
  { id: "mtb",      label: "MTB" },
  { id: "foldable", label: "Foldable" },
  { id: "e-dirt",   label: "E-Dirt" },
  { id: "cargo",    label: "Cargo" },
  { id: "kids",     label: "Kids" },
];

// No categories are "coming soon" any more — every series has a live model
export const COMING_SOON_CATEGORIES = [];

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
